import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { DataCell, CommonModal } from '../../TableUIKit';
import { useVoiceApi } from '../../auth/helper/api/voiceApi';

const VoiceNotificationSentPage = () => {



  const voiceApi = useVoiceApi();
  const [voiceNotifications, setVoiceNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // State for filters
  const [filters, setFilters] = useState({
    clientRequestId: null,
    clientGroupRequestId: null,
    notificationId: null,
    templateCategory: sessionStorage.getItem('templateCategory') || '', // Retrieve from sessionStorage
    voiceTemplateName: sessionStorage.getItem('voiceTemplateName') || '', // Retrieve from sessionStroage
    status: sessionStorage.getItem('status') === 'true' ? true : (sessionStorage.getItem('status') === 'false' ? false : null), // Retrieve from sessionStorage    
    createdDate: null, // Date picker
    sentAt: null, // Date picker
    futureDate: null, // Date picker
  });

  // State for filter options
  const [voiceCategories, setVoiceCategories] = useState([]);
  const [voiceTemplateNames, setVoiceTemplateNames] = useState([]);

  //for handling pagination
  const [page, setPage] = useState(0); // Starting from the first page
  const [size, setSize] = useState(3); // Number of items per page
  const [totalPages, setTotalPages] = useState(0); // To store total pages

  const [editingNotification, setEditingNotification] = useState(null);
  const [editFutureDate, setEditFutureDate] = useState('');
  const [editRePick, setEditRePick] = useState('');

  const [activeDetails, setActiveDetails] = useState(null);

  useEffect(() => {

    const fetchFilterOptions = async () => {
      try {
        const response = await voiceApi.get(
          process.env
            .REACT_APP_GET_ALL_VOICE_TEMPLATES_ENDPOINT
        );
        const { object } = response.data; // Assuming the response structure contains an array of template objects

        // Extracting necessary values for dropdowns
        const voiceCategories = [...new Set(object.map(template => template.voiceTemplateCategory.templateCategory))]; // voice template category which is linked to template
        const voiceTemplateNames = [...new Set(object.map(template => template.voiceTemplateName))]; // template names

        // Set these unique values to state
        setVoiceCategories(voiceCategories);
        setVoiceTemplateNames(voiceTemplateNames);
      } catch (err) {
        setError(err.message || 'Error fetching filter options.');
      }
    };
    fetchFilterOptions(); // Call to fetch options
  }, [voiceApi]); // Runs once when the component mounts

  useEffect(() => {

    const fetchVoiceNotifications = async () => {
      try {

        const response = await voiceApi.get(
          process.env
            .REACT_APP_GET_VOICE_NOTIFICATION_DETAILS_BY_PAGE_ENDPOINT,
          {
            params: {
              ...filters,
              page, // Add current page
              size, // Add items per page
            },
          }
        );

        const { message, object, httpStatus } = response.data;

        if (httpStatus === 200) {
          setVoiceNotifications(object.content); // Set the voicenotification from the response object
          setTotalPages(object.totalPages); // Update total pages from response
        } else {
          setError(`Error: ${message}`); // Handle non-success status code
        }
        console.log("voiceNotification: ", voiceNotifications);

        setLoading(false);
      } catch (err) {
        setError(err.message || 'An unexpected error occurred.');
        setLoading(false);
      }
    };

    fetchVoiceNotifications(); // Fetch voice notifications on component load
  }, [voiceApi, page, size]); // Add an empty dependency array to call on mount



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      const newFilters = { ...prev, [name]: value };
      // Store the selected values in localStorage
      sessionStorage.setItem(name, value);
      return newFilters;
    });
  };

  const handleDateChange = (date, fieldName) => {
    setFilters((prev) => ({
      ...prev,
      [fieldName]: date,
    }));
  };

  const handleEditClick = (notification) => {
    // Set the notification being edited
    setEditingNotification(notification.id);
    setEditRePick(notification.rePick)//set rePick status to edit
    setEditFutureDate(
      notification.futureDate ? new Date(notification.futureDate) : null
    ); // Set the futureDate to edit
  };

  const handleEditSubmit = async (notificationId) => {

    try {
      // Update notification with PUT request

      await voiceApi.put(
        `${process.env.REACT_APP_SET_VOICE_NOTIFICATION_DETAILS_ENDPOINT}/${notificationId}`,
        {
          rePick: editRePick,
          futureDate: editFutureDate,
        }
      );

      // Refresh the templates list after the update
      const updatedNotification = voiceNotifications.map((notification) => {
        if (notification.id === notificationId) {
          return { ...notification, rePick: editRePick, futureDate: editFutureDate }; // Update the edited notification
        }
        return notification; // Keep the other records unchanged
      });
      setVoiceNotifications(updatedNotification);
      setEditingNotification(null); // Reset editing state
      setEditRePick('')//clear
      setEditFutureDate(''); // clear
    } catch (err) {
      setError(err.message || 'An error occurred while updating the Template.');
    }
  };

  const toggleActivationStatus = async (notificationId, currentStatus) => {

    try {
      const newStatus = !currentStatus; // Toggle activation status
      await voiceApi.patch(
        `${process.env.REACT_APP_SET_VOICE_NOTIFICATION_STATUS_ENDPOINT}/${notificationId}`,
        { status: newStatus }
      );
      // Update the local state after toggling the status
      setVoiceNotifications((prev) => prev.map(notification =>
        notification.id === notificationId ? { ...notification, status: newStatus } : notification
      ));
    } catch (err) {
      setError(err.message || 'An error occurred while updating the status.');
    }
  };

  // Handle the status change to convert to boolean
  const handleStatusChange = (e) => {
    const value = e.target.value;
    const statusValue = value === 'sent' ? true : value === 'not-sent' ? false : null;

    setFilters((prev) => {
      const newFilters = { ...prev, status: statusValue };
      // Store the status in localStorage
      sessionStorage.setItem('status', statusValue);
      return newFilters;
    });
  };

  // New function to apply filters
  const applyFilters = async () => {

    setLoading(true); // Show loading while fetching filtered notifications
    try {

      const response = await voiceApi.get(
        process.env
          .REACT_APP_GET_VOICE_NOTIFICATION_DETAILS_BY_PAGE_ENDPOINT,
        {
          params: {
            ...filters, ...filters,
            page,
            size,
          },
        }
      );

      const { message, object, httpStatus } = response.data;

      if (httpStatus === 200) {
        setVoiceNotifications(object.content); // Set the voicenotification from the response object
        setTotalPages(object.totalPages); // Update total pages from response
      } else {
        setError(`Error: ${message}`); // Handle non-success status code
      }

    } catch (err) {
      setError(err.message || 'Failed to fetch notifications.');
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  const handleNextPage = () => {
    if (page + 1 < totalPages) {
      setPage((prevPage) => prevPage + 1); // Increment page number
    }
  };

  const handlePreviousPage = () => {
    if (page > 0) {
      setPage((prevPage) => prevPage - 1); // Decrement page number
    }
  };

  const handleSizeChange = (e) => {
    setSize(e.target.value);
    setPage(0); // Reset to first page on changing size
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error fetching voice notifications: {error.message}</div>;

  return (
    <div className="table-container">
      <h1>Voice Notifications</h1>
     <div className="flex-row filter-section">
        <div className='filter-item'>
          <label htmlFor="items-per-page">Items per page: </label>
          <select id="items-per-page" onChange={handleSizeChange} className="w-auto">
            <option value={3}>default</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
          </select>
        </div>
      </div>
      <h3>Filters</h3>
      {/* Filter Form */}
      <div className="flex-row filter-section">
        <div className="filter-item">
          <label>Voice Category:</label>
          <select name="templateCategory" onChange={handleInputChange} value={filters.templateCategory}>
            <option value="">All</option>
            {voiceCategories.map((templateCategory, index) => (
              <option key={index} value={templateCategory}>
                {templateCategory}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <label>Voice Template Name:</label>
          <select name="voiceTemplateName" onChange={handleInputChange} value={filters.voiceTemplateName}>
            <option value="">All</option>
            {voiceTemplateNames.map((voiceTemplateName, index) => (
              <option key={index} value={voiceTemplateName}>
                {voiceTemplateName}
              </option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <label>ClientRequestId:</label>
          <input
            type="text"
            name="clientRequestId"
            value={filters.clientRequestId ?? ''}
            onChange={handleInputChange}
          />
        </div>

        <div className="filter-item">
          <label>GroupClientRequestId:</label>
          <input
            type="text"
            name="clientGroupRequestId"
            value={filters.clientGroupRequestId ?? ''}
            onChange={handleInputChange}
          />
        </div>

        <div className="filter-item">
          <label>notificationId:</label>
          <input
            type="text"
            name="notificationId"
            value={filters.notificationId ?? ''}
            onChange={handleInputChange}
          />
        </div>


        <div className="filter-item">
          <label>Status:</label>
          <select name="status" onChange={handleStatusChange} value={filters.status === null ? '' : filters.status ? 'sent' : 'not-sent'}>
            <option value="">All</option>
            <option value="sent">Sent</option>
            <option value="not-sent">Not Sent</option>
          </select>
        </div>

        <div className="filter-item">
          <label>Created At:</label>
          <DatePicker
            selected={filters.createdDate}
            onChange={(date) => handleDateChange(date, 'createdDate')}
            dateFormat="yyyy-MM-dd" // Adjust format as needed
            isClearable
            placeholderText="Select a date"
          />
        </div>

        <div className="filter-item">
          <label>Sent At:</label>
          <DatePicker
            selected={filters.sentAt}
            onChange={(date) => handleDateChange(date, 'sentAt')}
            dateFormat="yyyy-MM-dd" // Adjust format as needed
            isClearable
            placeholderText="Select a date"
          />
        </div>

        <div className="filter-item">
          <label>Future Date:</label>
          <DatePicker
            selected={filters.futureDate}
            onChange={(date) => handleDateChange(date, 'futureDate')}
            dateFormat="yyyy-MM-dd" // Adjust format as needed
            isClearable
            placeholderText="Select a date"
          />
        </div>

        <button type="button" onClick={applyFilters}>Apply Filters</button>

      </div>

      <h2>Voice Notifications Status</h2>

      <div className="table-responsive">
        <table className="notifications-table">
          <thead>
            <tr>
              <th>id</th>
              <th>Notification ID</th>
              <th>orgDLTEntityId</th>
              <th>Caller Phone Id</th>
              <th>Voice Message Text</th>
              <th>Voice Message Type</th>
              <th>Customer Calling ReqId</th>
              <th>Voice Message Request Cat</th>
              <th>Voice Template Category</th>
              <th>Platform API Name</th>
              <th>Voice Template Name</th>
              <th>Receipient List</th>
              <th>Sent At</th>
              <th>Status</th>
              <th>Re Pick</th>
              <th>Created At</th>
              <th>Updated At</th>
              <th>Client Request ID</th>
              <th>Group Request ID</th>
              <th>Future Date</th>
              <th>Voice Request</th>
              <th>Voice External Request</th>
              <th>Voice Response</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {voiceNotifications.map((notification) => (
              <tr key={notification.id}>
                <td>{notification.id}</td>
                <td>{notification.notificationId}</td>
                <td>{notification.orgDLTEntityId}</td>
                <td>{notification.callerPhoneId}</td>
                <DataCell label="Voice Message Text" value={notification.voiceMessageText} onClick={setActiveDetails} />
                <td>{notification.voiceMessageType}</td>
                <td>{notification.customerCallingReqId}</td>
                <td>{notification.voiceMessageRequestCategory}</td>
                <td>{notification.platformAPIName}</td>
                <td>{notification.voiceTemplateCategory.templateCategory}</td>
                <td>{notification.voiceTemplate.voiceTemplateName}</td>
                <td>{notification.receipientList}</td>
                <td>{new Date(notification.sentAt).toLocaleString()}</td>
                <td>{notification.status ? 'Sent' : 'Not Sent'}</td>
                <td>
                  {editingNotification === notification.id ? (
                    <select
                      value={
                        editRePick === null
                          ? ""
                          : editRePick
                            ? "true"
                            : "false"
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val === "") {
                          setEditRePick(null);
                        } else {
                          setEditRePick(val === "true");
                        }
                      }}
                    >
                      <option value="true">True</option>
                      <option value="false">False</option>
                    </select>
                  ) : (
                    // display value when not editing
                    notification.rePick ? "True" : "False"
                  )}
                </td>
                <td>{new Date(notification.createdTimestamp).toLocaleString()}</td>
                <td>{new Date(notification.updatedTimestamp).toLocaleString()}</td>
                <td>{notification.clientRequestId}</td>
                <td>{notification.groupRequestId}</td>
                <td>
                  {editingNotification === notification.id ? (
                    <DatePicker
                      selected={editFutureDate}
                      onChange={(date) => setEditFutureDate(date)}
                      dateFormat="yyyy-MM-dd"
                      isClearable
                      placeholderText="Select a date"
                    />
                  ) : (
                    notification.futureDate ? new Date(notification.futureDate).toLocaleString() : 'N/A'
                  )}
                </td>
                <DataCell label="Voice Request" value={notification.voiceRequest} onClick={setActiveDetails} />
                <DataCell label="Voice External Request" value={notification.voiceExternalRequest} onClick={setActiveDetails} />
                <DataCell label="Voice Response" value={notification.voiceResponse} onClick={setActiveDetails} />
                <td>
                  <div className="action-buttons">
                    {editingNotification === notification.id ? (
                      <button onClick={() => handleEditSubmit(notification.id)}>Save</button>
                    ) : (
                      <button onClick={() => handleEditClick(notification)}>Edit</button>
                    )}
                    <button onClick={() => toggleActivationStatus(notification.id, notification.status)}>
                      {notification.status ? 'Disable' : 'Enable'}
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      <div className="pagination-container">
        <button onClick={handlePreviousPage} disabled={page === 0}>Previous</button>
        <span>Page {page + 1} of {totalPages}</span>
        <button onClick={handleNextPage} disabled={page + 1 === totalPages}>Next</button>
      </div>
      {/* ONE MODAL TO RULE THEM ALL */}
      <CommonModal
        isOpen={!!activeDetails}
        onClose={() => setActiveDetails(null)}
        /* Pull the dynamic title from state */
        title={activeDetails?.title || "Details"}
        copyValue={activeDetails?.text}
      >
        {activeDetails?.text}
      </CommonModal>
    </div>
  );
};

export default VoiceNotificationSentPage;
